const TOPNAV_PAGE_SIZE = 5;
const ACTIVITYPAGE_PAGE_SIZE = 15;

const TWO_MINUTES = 120000;
const ONE_MINUTE = 60000;

const FOOTER_BUFFER = 500;

const SCROLL_THROTTLE = 300;

const FA_KEYWORDS = {
  clipLike: 'video_like',
  userFollow: 'user_follow',
  clipComment: 'comment',
  commentReply: 'comment_reply',
  clipCredit: 'video_credit',
  commentMention: 'comment_mention',
  userMessage: 'message',
  clipTranscodeComplete: 'upload',
  clipShare: 'video_share',
  channelFollow: 'channel_follow',
  vodNewPurchase: 'vod_purchase',
  vodPreorderRelease: 'vod_preorder',
  vodRentalExpire: 'vod_expire',
  seeAll: 'see_all',
  newNotifications: 'new_notifications',
  noNotifications: 'no_notifications',
};

const FA_CONTAINERS = {
  ACTIVITYPAGE: 'activity_feed',
  TOPNAV: 'top_nav',
  DROPDOWN: 'notifications',
};

const FA_COMPONENTS = {
  ACTIVITY: 'notification',
  FOLLOW: 'follow',
  UNFOLLOW: 'unfollow',
  TOPNAV: 'notifications',
  DROPDOWN: 'panel',
  CTA_THUMBNAIL: 'thumbnail',
  CTA_VIEW: 'view',
  AVATAR: 'avatar',
};

export {
  TOPNAV_PAGE_SIZE,
  ACTIVITYPAGE_PAGE_SIZE,
  TWO_MINUTES,
  ONE_MINUTE,
  FOOTER_BUFFER,
  SCROLL_THROTTLE,
  FA_COMPONENTS,
  FA_CONTAINERS,
  FA_KEYWORDS,
};
